const pre = '/UI/userLocation/'

export default {
  SET_USER_LOCATION: `${pre}SET_USER_LOCATION`
}
